import type {MenuButtonProps} from '@chakra-ui/react';
import {MenuButton, forwardRef} from '@chakra-ui/react';

type Props = {} & MenuButtonProps;

const ContextMenuTrigger = forwardRef(({children, ...props}, ref) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    // Stop propagation to prevent click handler on the parent from firing
    e.stopPropagation();
    props.onClick?.(e);
  };
  return (
    <MenuButton {...props} ref={ref} onClick={handleClick}>
      {children}
    </MenuButton>
  );
});

export default ContextMenuTrigger;
export type {Props as ContextMenuButtonProps};
